import IssuesService from 'src/modules/issues/issuesService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'ISSUES_FORM';

const issuesFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: issuesFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await IssuesService.find(id);
      }

      dispatch({
        type: issuesFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: issuesFormActions.INIT_ERROR,
      });

      getHistory().push('/issues');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: issuesFormActions.CREATE_STARTED,
      });

      await IssuesService.create(values);

      dispatch({
        type: issuesFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.issues.create.success'),
      );

      getHistory().push('/issues');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: issuesFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: issuesFormActions.UPDATE_STARTED,
      });

      await IssuesService.update(id, values);

      dispatch({
        type: issuesFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.issues.update.success'),
      );

      getHistory().push('/issues');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: issuesFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default issuesFormActions;
